export const getMonthOrderBy = {
  "01": {jan: "desc"},
  "02": {feb: "desc"},
  "03": {mar: "desc"},
  "04": {april: "desc"},
  "05": {may: "desc"},
  "06": {june: "desc"},
  "07": {july: "desc"},
  "08": {aug: "desc"},
  "09": {sept: "desc"},
  "10": {oct: "desc"},
  "11": {nov: "desc"},
  "12": {dec: "desc"}
};

export const checkNull = {
  "01": {jan: { _is_null: false }},
  "02": {feb:{ _is_null: false }},
  "03": {mar:{ _is_null: false }},
  "04": {april:{ _is_null: false }},
  "05": {may:{ _is_null: false }},
  "06": {june:{ _is_null: false }},
  "07": {july:{ _is_null: false }},
  "08": {aug:{ _is_null: false }},
  "09": {sept:{ _is_null: false }},
  "10": {oct:{ _is_null: false }},
  "11": {nov:{ _is_null: false }},
  "12": {dec:{ _is_null: false }}
}

export const checkZero = {
  "01": {jan: { _neq: 0 }},
  "02": {feb:{ _neq: 0 }},
  "03": {mar:{ _neq: 0 }},
  "04": {april:{ _neq: 0 }},
  "05": {may:{ _neq: 0 }},
  "06": {june:{ _neq: 0 }},
  "07": {july:{ _neq: 0 }},
  "08": {aug:{ _neq: 0 }},
  "09": {sept:{ _neq: 0 }},
  "10": {oct:{ _neq: 0 }},
  "11": {nov:{ _neq: 0 }},
  "12": {dec:{ _neq: 0 }}
}

export const getMonthObject = (month, value) => {
  const monthNames = [
    "jan", "feb", "mar", "april", "may", "june",
    "july", "aug", "sept", "oct", "nov", "dec"
  ];

  const monthKey = monthNames[parseInt(month, 10) - 1];

  return {
    [monthKey]: value
  };
}
